import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Nav from "./components/Nav";
import Footer from "./components/Footer";

import Home from './Home';
import PropertySearch from './PropertySearch';
import Property from './Property';
import SignUp from './SignUp';
import BookAViewing from './BookAViewing';
import MakeAnOffer from './MakeAnOffer';
import ScrollToTop from "./components/ScrollToTop";
import ReactPixel from 'react-facebook-pixel';
import BookAppraisalSuccess from "./BookAppraisalSuccess";
import BookAnAppraisal from "./BookAnAppraisal";

// import '../sass/styles.scss';

class App extends React.Component {

    componentDidMount() {
        ReactPixel.init('2289926061323683');
        ReactPixel.pageView();
    }

    render() {
        return (
        <>
            <Nav />
            <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/buy" component={PropertySearch} />
                <Route path="/let" component={PropertySearch} />
                <Route path="/commercial" component={PropertySearch} />
                <Route exact path="/property/:id" component={Property} />
                <Route exact path="/book-an-appraisal" component={BookAnAppraisal} />
                <Route exact path="/book-an-appraisal/thank-you" component={BookAppraisalSuccess} />
                <Route exact path="/sign-up" component={SignUp} />
                <Route exact path="/book-a-viewing/:property" component={BookAViewing} />
                <Route exact path="/make-an-offer/:property" component={MakeAnOffer} />
            </Switch>
            <Footer />
            <ScrollToTop />
        </>
    )}
}

export default App;
